import React, { useContext } from 'react';
import { Step } from './steps';
import StepsList from './steps-list';
import context from '../../../../../../hoc/context/product/context';
import { EmailSVG } from '../../../../../../hoc/components/icon/svgs/emailVector';
import { HeaderStep } from './step';
import { AdherenceIcon } from '../../../../../../../assets/images/adherence-icon';

const ExpectedNextSteps: React.FC<{ steps: Step[] }> = ({ steps }) => {
	const ctxt = useContext(context);
	const stepsList: HeaderStep[] = [];

	steps.forEach((step) => {
		if ('email' === step.name) {
			stepsList.push({
				name: 'email',
				icon: (
					<EmailSVG
						className="fill-icon"
						title={ctxt.json.pages.icons.communication}
					/>
				),
				title: ctxt.json.pages.icons.communication,
				description: ctxt.json.pages.confirmation.header.inbox,
			});
		}
		if ('tcpa' === step.name) {
			stepsList.push({
				name: 'tcpa',
				icon: (
					<AdherenceIcon
						className="fill-icon"
						title={ctxt.json.pages.icons.adherence}
					/>
				),
				title: ctxt.json.pages.icons.adherence,
				description: ctxt.json.pages.confirmation.header.personalSupport,
			});
		}
	});

	return <StepsList steps={stepsList} />;
};

export default ExpectedNextSteps;
